import React, { useState, useEffect } from "react";

//
import Moment from "react-moment";
import { Col, Row, Card } from "react-bootstrap";

//
import RadialChart from "../general/RadialChart";
import BoxLoading from "../general/BoxLoading";

//
import { getFearGreed } from "../../redux/features/coins/actions";

function CurrenctFearGreed() {
  const [loading, setLoading] = useState(false);
  const [fearGreed, setFearGreed] = useState([]);

  /**
   * Get Fear & Greed
   */
  const get_fear_greed = async () => {
    // start loading
    setLoading(true);

    // request
    await getFearGreed().then((res) => {
      if (res) {
        setFearGreed(res);
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    get_fear_greed();

    // eslint-disable-next-line
  }, []);

  /**
   * Convert Title To Color
   */
  const convertTitleToColor = (title) => {
    if (title === "Extreme Greed") return "info";
    if (title === "Greed") return "success";
    if (title === "Fear") return "warning";
    if (title === "Extreme Fear") return "danger";
    if (title === 'Neutral') return 'light-warning'
  };

  return (
    <Card className="current-fear-greed">
      <Row>
        <Col xs={12} sm={7}>
          <RadialChart title="Current Fear & Greed Index" data={fearGreed.length ? fearGreed[0] : {}}/>
        </Col>

        <Col className="d-block d-sm-none">
          <div className="space"></div>
        </Col>

        <Col xs={12} sm={5} className="infos">
          <div className="holder">
            {fearGreed.map((item, index) => (
              <div
                className={
                  `item ${convertTitleToColor(item.value_classification)}`
                }
                key={index}
              >
                <h5 className="amount">{item.value}</h5>

                <div>
                  <small>{item.value_classification}</small>
                  <p>
                    {index === 0 ? (
                      <>Previous Close</>
                    ) : (
                      <Moment unix fromNow>
                        {item.timestamp}
                      </Moment>
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>

      {
        loading && (
          <BoxLoading/>
        )
      }
    </Card>
  );
}

export default CurrenctFearGreed;
